import React from "react";
import { Form, Button } from "semantic-ui-react";
import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import "../css/Register.css";
import "../css/SelectRegister.css";

export default function RegisterSuperAdmin() {
    const [universityName, setUniversityName] = useState();
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [email, setEmail] = useState();
    const [accountError, setAccountError] = useState();
    const [domain, setDomain] = useState("@domain.edu");
    const [pass, setPass] = useState();
    const [confirmPass, setConfirmPass] = useState();
    const [passError, setPassError] = useState();
    const [universityNameError, setUniversityNameError] = useState();
    const [domainError, setDomainError] = useState();

    var userid = 0;
    const firstNameFormIndex = 0;
    const lastNameFormIndex = 1;
    const universityNameFormIndex = 2;
    const emailFormIndex = 3;
    const domainFormIndex = 4;
    const passFormIndex = 5;
    const confirmPassFormIndex = 6;

    let navigate = useNavigate();

    const redirectLogin = () => {
        navigate("/");
    };

    const redirectUniInfo = () => {
        navigate("/UniversityInfo");
    };

    return (
        <div className="register">
            <div className="ui center aligned padded grid register-box">
                <div className="row">
                    <div className="register-blue-sidebar column five wide">
                        <h2 className="register-app-title">Student Events</h2>
                    </div>
                    <div className="register-form column eleven wide">
                        <h2 className="create-account-heading">
                            CREATE YOUR ACCOUNT
                        </h2>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group widths="equal">
                                <Form.Input
                                    fluid
                                    placeholder="First name"
                                    required
                                    onChange={(e) =>
                                        setFirstName(
                                            e.target.form[firstNameFormIndex].value
                                        )
                                    }
                                />
                                <Form.Input
                                    fluid
                                    placeholder="Last name"
                                    required
                                    onChange={(e) =>
                                        setLastName(
                                            e.target.form[lastNameFormIndex].value
                                        )
                                    }
                                />
                            </Form.Group>
                            <Form.Input
                                fluid
                                placeholder="Name of Your University"
                                required
                                onChange={(e) =>
                                    setUniversityName(
                                        e.target.form[universityNameFormIndex].value
                                    )
                                }
                                error={universityNameError}
                            />
                            <Form.Group className="email">
                                <Form.Input
                                    fluid
                                    placeholder="Email"
                                    required
                                    width={12}
                                    onChange={(e) =>
                                        setEmail(
                                            e.target.form[emailFormIndex].value
                                        )
                                    }
                                    error={accountError}
                                />
                                <p className="email-at">@</p>
                                <Form.Input
                                    fluid
                                    placeholder="University Email Domain"
                                    required
                                    width={8}
                                    onChange={(e) =>
                                        setDomain(
                                            e.target.form[domainFormIndex].value
                                        )
                                    }
                                    error={domainError}
                                />
                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Input
                                    type="password"
                                    fluid
                                    placeholder="Password"
                                    required
                                    onChange={(e) =>
                                        setPass(e.target.form[passFormIndex].value)
                                    }
                                    error={passError}
                                />
                                <Form.Input
                                    type="password"
                                    fluid
                                    placeholder="Confirm Password"
                                    required
                                    onChange={(e) =>
                                        setConfirmPass(
                                            e.target.form[confirmPassFormIndex]
                                                .value
                                        )
                                    }
                                    error={!!passError}
                                />
                            </Form.Group>
                            <div className="regstu-button">
                                <Button className="selectreg-btn">REGISTER</Button>
                            </div>
                            <a className="direct-to-login" onClick={redirectLogin}>
                                Already have an account? Login
                            </a>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );

    // Check if the university name or domain is already taken
    async function checkUniversityAvailibility() {
        try {
            let info = {
                name: universityName,
                domain: "@" + domain,
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/checkUniversity.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            var res = await response.json();

            console.log(res.error);

            if (res.error === "University name is taken")
                setUniversityNameError(res.error);
            else if (res.error === "University domain is taken")
                setDomainError(res.error);
            else
            {
                console.log("University name and domain are valid");
                return true;
            }
        } catch (error) {
            console.log(error);
        }
        return false;
    }

    /*access login php*/
    async function getAdminId() {
        try {
            let info = {
                email: email + "@" + domain,
                password: pass
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/login.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            var res = await response.json();

            console.log(res.error);

            if (res.error === "No Records Found")
                console.log("wrong email and password");
            else
            { 
                userid = res.id;
                localStorage.setItem("userid", res.id);
                console.log("userid: " + userid);
                await createUniversity();
            }
        } catch (error) {
            console.log(error);
        }
    }

    /*access createuniversity php*/
    async function createUniversity() {
        try {
            let info = {
                super_adminid: userid,
                name: universityName,
                domain: "@" + domain,
                description: "",
                location: "",
                no_student: 0
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/createUniversity.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            var res = await response.json();

            console.log("createUniversity res: ", res);

            if (res.error === "")
            {
                console.log("Successfully created university");
                redirectUniInfo();
            }
            else
            {
                console.log("Unsuccessfully created university");
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function registerSuperAdmin() {
        try {
            let info = {
                firstname: firstName,
                lastname: lastName,
                email: email + "@" + domain,
                password: pass,
                confirmpassword: confirmPass,
                adminorsuper: 1,
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/register.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            var res = await response.json();

            if (res.error !== "") {
                console.log(res.error);
                if (res.error !== "User already exists.") {
                    setPassError(res.error);
                } else {
                    setAccountError(res.error);
                }
            } else {
                await getAdminId();
                console.log("Registration successful");
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function handleSubmit() {
        console.log("handling submit");
        setPassError();
        setAccountError();
        setUniversityNameError();
        setDomainError();

        // Check to make sure that the university name and domain are available
        let universityAvailableBool = await checkUniversityAvailibility();

        // Call the register API
        console.log("uni name error: " + !!universityNameError);
        console.log("domain error: " + !!domainError);

        if (universityAvailableBool) {
            await registerSuperAdmin();
        } else {
            console.log("Could not register user because of university");
        }
    }
}
